import React from 'react';

const LocalizacionRow = (props) => {

    const {medio,funcionModificar,funcionEliminar, permisoModificacion, permisoBaja } = props;
    let domicilio = '';
    let sinBordeDerecho= false;
    let tipo="";
    if(medio.Calle){
        domicilio += medio.Calle + ' '+medio.Numero+', '+ (medio.Piso ? ("Piso " + medio.Piso + ' Depto. ' + medio.Departamento + " - "):' - ')+ medio.Localidad + ', CP '+ medio.CodigoPostal + ', '+ medio.ProvinciaDescripcion+', '+ medio.PaisDescripcion; 
    }

    tipo = medio.MedioCodigo ? medio.MedioCodigo.toLowerCase() : "";
    if(tipo == "telfijo") tipo = "fijo";

    switch (medio.MedioCodigo){
        case "TELFIJO": {
            sinBordeDerecho = true;
            break;
        }
        case "CELULAR": {
            sinBordeDerecho = true;
            break;
        }
    }
    
        return ( 
            <tr className="">
                    <td className={sinBordeDerecho ? 'bordeBlancoLocalizacionDerecha' : ""}>
                        {(medio.TipoProducto == "Tarjeta Prepaga" || medio.TipoProducto == "ambas") && (medio.MedioNombre != "POSTAL" || medio.EsDomicilioLegal) && medio.MedioNombre != "ELECTRONICO" && <label className='icon-cuentas tarjetaCreditoIcon'></label>}
                        {((medio.TipoProducto && medio.TipoProducto.includes("de")) || medio.TipoProducto == "ambas") && (medio.MedioNombre != "POSTAL" || medio.EsDomicilioLegal) &&<label className='icon-cuentasCred tarjetaCreditoIcon'></label>}
                    </td>
                    <td>
                        {((medio.TipoProducto == "Tarjeta Prepaga" || medio.TipoProducto == "ambas") &&(medio.MailMedioCorrespondencia || medio.EsDomicilioCorrespondencia )) && <label className='icon-cuentas tarjetaCreditoIcon'></label>}
                        {((medio.TipoProducto == "Tarjeta de crédito" || medio.TipoProducto == "ambas")&&(medio.MailMedioCorrespondencia || medio.EsDomicilioCorrespondencia )) &&<label className='icon-cuentasCred tarjetaCreditoIcon'></label>}
                    </td>
                    <td className='bordeBlancoLocalizacionDerecha'>
                        {medio.Calle ? domicilio : medio.Contacto}
                    </td>
                    {!medio.Calle && <td className='bordeBlancoLocalizacionIzquierda bordeBlancoLocalizacionDerecha'>
                        {tipo}
                    </td>}
                    {/* <td>
                        {permisoModificacion && <label onClick={()=>funcionModificar(medio,true)} className="rowTextVistaCliente icon-editar accionesTablaCliente bordeBlancoLocalizacionIzquierda clickable"></label>}
                        {permisoBaja && <label onClick={()=>funcionEliminar(medio,true, medio.MedioNombre == "POSTAL"  ? medio.Id : false )} className="rowTextVistaCliente icon-eliminar accionesTablaCliente bordeBlancoLocalizacionIzquierda"></label>}
                    </td> */}
                </tr>
         );   
}
 
export default LocalizacionRow;